(function () {
  const U = window.TBX = {};

  const LS_MODE = "riftbound-tb-mode";

  const TB = {
    online: null,
    canRecord: true,
    sets: [],
    manifests: {},
    loaded: false,
    feedback: {},
    sel: null,
    filter: "all",
    search: "",
    mode: (function () { try { return localStorage.getItem(LS_MODE) || "cards"; } catch (e) { return "cards"; } })(),
    folds: (function () { try { return JSON.parse(localStorage.getItem("riftbound-tb-folds") || "{}"); } catch (e) { return {}; } })(),
    tab: "cards",
    covSet: null,
    covShape: null,
    covFilter: "manual",
    covQuery: "",
    run: null,
    status: "",
    barNote: "",
    barTags: [],
    barExpanded: true,
    rules: { open: false, query: "", title: "", entries: [], loading: false },
  };
  window.TB = TB;

  const FAIL_REASONS = [
    { k: "board", label: "Insufficient board", hint: "the scenario cannot exercise the card" },
    { k: "proc", label: "Procedural error", hint: "wrong rules or engine behaviour" },
    { k: "anim", label: "Broken animation", hint: "missing, wrong or conflicting animation" },
    { k: "art", label: "Missing sprite", hint: "a card or token renders without art" },
    { k: "ui", label: "Unclear UI", hint: "mechanically right but reads wrong" },
    { k: "rules", label: "Rules check", hint: "verify against the rules, may turn into a pass" },
  ];
  const REASON_BY_KEY = {};
  for (const r of FAIL_REASONS) REASON_BY_KEY[r.k] = r;

  function reasonLabel(k) { return (REASON_BY_KEY[k] || {}).label || k; }

  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const fmtText = window.UIDOM.fmtText;

  function fmtTs(ts) {
    if (!ts) return "";

    const s = typeof ts === "number" ? new Date(ts).toISOString() : String(ts);
    return s.replace("T", " ").slice(0, 16);
  }

  function api(method, path, body) {
    return fetch(path, {
      method: method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.error || r.statusText); });
      return r.json();
    });
  }

  function render() {
    UI.render();
  }

  TB.open = function () {
    APP.screen = "testbench";
    APP.error = null;
    TB.status = "";
    api("GET", "/api/ping").then(function (info) {
      TB.canRecord = info.feedback !== false;
      return api("GET", "/api/sets");
    }).then(function (sets) {
      TB.online = true;
      TB.sets = sets;
      return TB.loadAll();
    }).catch(function () {
      TB.online = false;
      render();
    });
    render();
  };

  TB.loadAll = function () {
    entriesCache = null;
    TB.loaded = false;
    TB.manifests = {};
    TB.feedback = {};
    TB.sel = null;
    return Promise.all(TB.sets.map(function (b) {
      return Promise.all([api("GET", "/api/set/" + b.id), api("GET", "/api/feedback/" + b.id)])
        .then(function (rs) {
          TB.manifests[b.id] = rs[0];
          const fb = TB.feedback[b.id] = {};
          for (const entry of rs[1]) {
            (fb[entry.card] = fb[entry.card] || []).push(entry);
          }
        });
    })).then(function () {
      TB.loaded = true;
      const first = allEntries().find(function (e2) { return !verdictFor(e2); });
      TB.sel = first ? entryKey(first) : (allEntries()[0] ? entryKey(allEntries()[0]) : null);
      render();
    }).catch(function (e) {
      TB.status = "Failed to load sets: " + e.message;
      render();
    });
  };

  let entriesCache = null;

  function allEntries() {
    if (entriesCache) return entriesCache;
    const out = [];
    for (const b of TB.sets) {
      const m = TB.manifests && TB.manifests[b.id];
      if (!m) continue;
      for (const entry of m.cards || []) {
        if (!entry.__set) entry.__set = b.id;
        out.push(entry);
      }
    }
    if (TB.loaded) entriesCache = out;
    return out;
  }

  function entryKey(entry) {
    return entry.__set + "|" + entry.card;
  }

  function setOf(entry) {
    return entry.__set;
  }

  TB.toggleFold = function (set) {
    if (TB.folds[set]) delete TB.folds[set];
    else TB.folds[set] = 1;
    try { localStorage.setItem("riftbound-tb-folds", JSON.stringify(TB.folds)); } catch (e) { }
    render();
  };

  function verdictFor(entry) {
    const own = TB.feedback[entry.__set];
    const list = own && own[entry.card];
    if (!list || !list.length) return null;
    let best = list[0];
    for (const v of list) if (String(v.ts || "") >= String(best.ts || "")) best = v;
    return best;
  }

  function cardEntry(key) {
    return allEntries().find(function (e2) { return entryKey(e2) === key; });
  }

  function dbCard(cardId) {
    return RB.Setup.findCard(cardId);
  }

  function entryCard(entry) {
    if (!entry) return null;
    return dbCard(entry.cover || entry.card);
  }

  function entryName(entry) {
    if (!entry) return "";
    const c = entryCard(entry);
    return entry.name || (c && c.name) || entry.card;
  }

  const statusCache = {};

  function scriptStatus(c) {
    if (!c) return ["?", "unknown", []];
    const key = c.id || c.name;
    if (statusCache[key]) return statusCache[key];
    return (statusCache[key] = computeScriptStatus(c));
  }

  function computeScriptStatus(c) {
    try {
      const s = RB.Scripts.build(c);
      if (s.unscripted) return ["manual", "falls back to manual resolution", s.manualLines || []];
      return ["scripted", "scripted", []];
    } catch (e) {
      return ["error", "script build error: " + e.message, [c.text || ""]];
    }
  }

  const BACKLOG_SHAPES = [
    { k: "deathknell", label: "Deathknell", re: /^\[Deathknell\]/i },
    { k: "levelgate", label: "Level gates", re: /^\[Level \d+\]\[>\]/i },
    { k: "empower", label: "Empower", re: /^\[Empower(ed)?\]/i },
    { k: "equip", label: "Equip / attach", re: /^\[Equip\]|attach(ed)?\b/i },
    { k: "activated", label: "Activated abilities", re: /(^|\s)(:rb_exhaust:|:rb_energy_\d+:|:rb_rune_\w+:|Spend \d+ XP|Banish this)[^:]*:\s/i },
    { k: "playtrig", label: "On-play triggers", re: /^(When|As) (you play\b|I'm played)/i },
    { k: "combattrig", label: "Combat & movement triggers", re: /\bWhen (I|you|an?)\b.*\b(attack|block|showdown|kill|move|damage)/i },
    { k: "bftrig", label: "Hold / conquer / score triggers", re: /\bWhen you (hold|conquer|score)\b/i },
    { k: "turntrig", label: "Turn & phase triggers", re: /^(At the (start|end) of|The first time|Once each turn|When you (draw|recycle|reveal|empower|win|channel)\b)/i },
    { k: "othertrig", label: "Other triggers", re: /^(When|Whenever)\b/i },
    { k: "costmod", label: "Cost modification", re: /costs? :rb_\w+:.* less|reduce (my|its|this|the) cost|ignoring its cost|as an additional cost/i },
    { k: "entermod", label: "Enter replacements", re: /^(I|This|Friendly units|Units) enters?\b/i },
    { k: "counter", label: "Counters & replacements", re: /^(Counter\b|If .* would\b)/i },
    { k: "aura", label: "Static auras", re: /^(Your|Other|Friendly|Enemy|Each|All)\b.*\b(have|has|gets?|cost)/i },
    { k: "rulemod", label: "Global rule changes", re: /^(Players|Units|Opponents|Any amount)\b|can't\b/i },
    { k: "selfstatic", label: "Self statics", re: /^(I|This)\b/i },
    { k: "deckfilter", label: "Deck lookahead & selection", re: /^(Look at|Reveal|Search|Draw|Recycle)\b/i },
  ];

  function backlogShape(line) {
    for (const shape of BACKLOG_SHAPES) if (shape.re.test(line)) return shape.k;
    return "oneshot";
  }

  const SHAPE_LABELS = { oneshot: "One-shot effect bodies" };
  for (const shape of BACKLOG_SHAPES) SHAPE_LABELS[shape.k] = shape.label;

  function shapeLabel(k) { return SHAPE_LABELS[k] || k; }

  function matchesFilter(entry, filter) {
    const v = verdictFor(entry);
    if (filter === "todo" && v) return false;
    if (filter === "fail" && (!v || v.verdict !== "fail")) return false;
    if (filter === "pass" && (!v || v.verdict !== "pass")) return false;
    return true;
  }

  function visibleCards() {
    const q = TB.search.toLowerCase();
    const vis = allEntries().filter(function (entry) {
      if (!matchesFilter(entry, TB.filter)) return false;
      if (q) {
        const c = entryCard(entry);
        const hay = (entryName(entry) + " " + (entry.expected || "") + " " +
          (c ? (c.text || "") + " " + (c.types || []).join(" ") : "")).toLowerCase();
        if (hay.indexOf(q) < 0) return false;
      }
      return true;
    });

    const order = {};
    TB.sets.forEach(function (b, i) { order[b.id] = i; });
    return vis.slice().sort(function (a, b) {
      const sa = order[a.__set] || 0, sb = order[b.__set] || 0;
      if (sa !== sb) return sa - sb;
      return a.card < b.card ? -1 : a.card > b.card ? 1 : 0;
    });
  }

  function progress() {
    const cards = allEntries();
    const done = { pass: 0, fail: 0 };
    for (const entry of cards) {
      const v = verdictFor(entry);
      if (v) done[v.verdict] = (done[v.verdict] || 0) + 1;
    }
    return { total: cards.length, pass: done.pass, fail: done.fail, todo: cards.length - done.pass - done.fail };
  }

  function exportRunGame() {
    if (!TB.run || !APP.game) return null;
    return { version: APP.game.version, setup: APP.game.setup, log: APP.game.log };
  }

  TB.submit = function (setId, cardId, verdict, note, game, scenarioTitle, tags) {
    if (!TB.canRecord) return Promise.reject(new Error("verdicts are read-only here"));
    const entry = {
      set: setId,
      card: cardId,
      verdict: verdict,
      note: note || "",
      tags: verdict === "fail" ? (tags || []).slice() : [],
      scenario: scenarioTitle || null,
      engineVersion: Kernel.ENGINE_VERSION,
      game: game || null,
    };
    return api("POST", "/api/feedback", entry).then(function (r) {
      entry.ts = r.ts;
      const fb = TB.feedback[setId] = TB.feedback[setId] || {};
      (fb[cardId] = fb[cardId] || []).push(entry);
      const named = dbCard(cardId);
      TB.status = verdict.toUpperCase() + " recorded for " + (named ? named.name : cardId);
    }).catch(function (e) {
      TB.status = "Could not save feedback: " + e.message;
      throw e;
    });
  };

  function advanceSelection() {
    const cards = allEntries();
    const next = cards.find(function (c) { return !verdictFor(c); });
    if (next) TB.sel = entryKey(next);
  }

  TB.launch = function (entry, scenario) {
    const spec = Object.assign({}, (scenario && scenario.spec) || {});
    if (!spec.underTest && dbCard(entry.card)) spec.underTest = entry.card;
    let built;
    try {
      built = RB.Scenario.buildGame(spec);
    } catch (e) {
      TB.status = "Scenario failed to build: " + e.message;
      render();
      return;
    }
    TB.run = {
      set: entry.__set,
      card: entry.card,
      name: entryName(entry),
      expected: entry.expected || "",
      scenario: (scenario && scenario.title) || "Freeform",
    };
    TB.barNote = "";
    TB.barTags = [];
    TB.barExpanded = true;
    RB.setArtOverrides(spec.art || {});
    UI.loadTestGame(built.game);
    APP.viewAs = 0;
    render();
  };

  TB.toggleBarTag = function (k) {
    const i = TB.barTags.indexOf(k);
    if (i < 0) TB.barTags.push(k);
    else TB.barTags.splice(i, 1);
    render();
  };

  TB.barVerdict = function (verdict) {
    const run = TB.run;
    const game = exportRunGame();
    TB.submit(run.set, run.card, verdict, TB.barNote, game, run.scenario, TB.barTags).then(function () {
      TB.run = null;
      advanceSelection();
      APP.screen = "testbench";
      render();
    }).catch(function () { render(); });
  };

  TB.backToBench = function () {
    TB.run = null;
    APP.screen = "testbench";
    render();
  };

  TB.lookupRule = function (num) {
    TB.rules.open = true;
    TB.rules.loading = true;
    TB.rules.title = "Rule " + num;
    TB.rules.query = num;
    render();
    api("GET", "/api/rule/" + encodeURIComponent(num)).then(function (r) {
      TB.rules.entries = r.entries;
      TB.rules.loading = false;
      render();
    }).catch(function (e) {
      TB.rules.entries = [];
      TB.rules.loading = false;
      TB.rules.title = "Rules unavailable: " + e.message;
      render();
    });
  };

  TB.searchRules = function (q) {
    TB.rules.open = true;
    TB.rules.query = q;
    if (/^\d{3}(\.\w+)*$/.test(q.trim())) return TB.lookupRule(q.trim());
    TB.rules.loading = true;
    TB.rules.title = "Search: " + q;
    render();
    api("GET", "/api/rules?q=" + encodeURIComponent(q)).then(function (r) {
      TB.rules.entries = r.entries;
      TB.rules.loading = false;
      render();
    }).catch(function (e) {
      TB.rules.entries = [];
      TB.rules.loading = false;
      TB.rules.title = "Rules unavailable: " + e.message;
      render();
    });
  };

  Object.assign(U, { FAIL_REASONS: FAIL_REASONS, reasonLabel: reasonLabel, el: el, esc: esc, fmtText: fmtText, fmtTs: fmtTs, render: render, allEntries: allEntries, entryKey: entryKey, setOf: setOf, verdictFor: verdictFor, cardEntry: cardEntry, dbCard: dbCard, entryCard: entryCard, entryName: entryName, scriptStatus: scriptStatus, backlogShape: backlogShape, shapeLabel: shapeLabel, matchesFilter: matchesFilter, visibleCards: visibleCards, progress: progress, advanceSelection: advanceSelection, LS_MODE: LS_MODE });
})();
